export const footerRoutesData = [
  {
    name: "home",
    href: "/home",
  },
  {
    name: "about",
    href: "/about",
  },
  {
    name: "portfolio",
    href: "/portfolio",
  },

  {
    name: "contact",
    href: "/contact",
  },
 
];
export default footerRoutesData;
